import {
  StyledTabHeader,
  StyledTab
} from './Tabs.styled';
import { useAudio } from '../../providers/AudioContext';

export const TabHeader = ({ children }) => {
  return (
    <StyledTabHeader>
      {children}
    </StyledTabHeader>
  );
};

export const Tab = ({ children, isSelected, onSelect }) => {
  const { playSFX } = useAudio();
  return (
    <StyledTab $selected={isSelected} onMouseEnter={() => playSFX('hover')} onClick={() => { playSFX('button'); onSelect(); }}>
      {children}
    </StyledTab>
  );
};

